import { useQuery } from "@tanstack/react-query";
import { getEntityFollowers, getEntityFollowing } from "./services/network.service";

export const useEntityFollowers = (entityId?: string, params?: string) => {
  return useQuery({
    queryKey: ["entityFollowers", entityId, params],
    queryFn: () => getEntityFollowers(entityId!, params),
    enabled: !!entityId,
  });
};

export const useEntityFollowing = (entityId?: string, params?: string) => {
  return useQuery({
    queryKey: ["entityFollowing", entityId, params],
    queryFn: () => getEntityFollowing(entityId!, params),
    enabled: !!entityId,
  });
};
